import { Role } from '@kindo/universal';

import { UserStatus } from './OrgUserManagement.types';

export const ROLE_DISPLAY_NAMES: Record<Role, string> = {
  [Role.Admin]: 'Admin',
  [Role.Member]: 'Member'
};

export const STATUS_DISPLAY_NAMES: Record<UserStatus, string> = {
  [UserStatus.ACTIVE]: 'Active',
  [UserStatus.PENDING]: 'Pending'
};
